import React, { useEffect, useRef, useState } from 'react'
import useTranslation from 'hooks/useTranslation'
import BackBtn from 'components/buttons/BackBtn'
import { GET } from 'rest/request'
import Loading from '../Loading'
import { api } from 'rest/urls'
import Popup from './Popup'

export type ConsentType = 'privacy' | 'terms' | 'licenses'

const LICENSES_URL = `${process.env.PUBLIC_URL}/third-party-licenses.txt`

const escapeHtml = (text: string) => text
  .replace(/&/g, '&amp;')
  .replace(/</g, '&lt;')
  .replace(/>/g, '&gt;')
interface ConsentPreviewModalProps {
  type: ConsentType
  endpoint?: string
  title?: string
  close?: basic.BasicFunc
}

const ConsentPreviewPopup: React.FC<ConsentPreviewModalProps> = ({ type, endpoint, title, close }) => {
  const [isLoading, setLoading] = useState(true)
  const iframeRef = useRef<HTMLIFrameElement>(null)

  const { t } = useTranslation('basic')
  const writeToFrame = (html: string) => {
    const contentDocument = iframeRef.current?.contentDocument
    if (contentDocument) {
      contentDocument.open()
      contentDocument.write(html)
      contentDocument.close()
    }
  }

  const getDocument = async (endpoint: string) => {
    try {
      const response = await GET(endpoint)
      setLoading(false)
      if (typeof response === 'string') writeToFrame(response)
    } catch (error) {
      setLoading(false)
    }
  }

  const getLicenses = async () => {
    try {
      const response = await fetch(LICENSES_URL)
      const text = await response.text()
      setLoading(false)
      if (!response.ok || text.trimStart().startsWith('<')) return
      writeToFrame(`<pre style="margin:0;padding:0 1.5em;white-space:pre-wrap;word-break:break-word;font-size:12px;line-height:1.5">${escapeHtml(text)}</pre>`)
    } catch (error) {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (type === 'licenses') {
      getLicenses()

    } else {
      const url = endpoint || `${api.replace('/v1/', '')}/${type}`
      getDocument(url)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [type, endpoint])

  const heading = title || t(type)

  return (
    <Popup
      centered
      close={close}>
      <div className='popup--consent'>
        <div className='popup__title'>
          <div>{heading}</div>
        </div>
        <div className='popup__frame__container'>
          <iframe
            title={heading}
            ref={iframeRef}
          />
          {isLoading && <Loading middleOfPage />}
        </div>
        <div className='popup__buttons'>
          <BackBtn action={close} />
        </div>
      </div>
    </Popup>
  )
}

export default ConsentPreviewPopup